import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, Icon, Input, UiButton } from '@shared/ui';
import {
    IRequestMaterialSinglePosition,
    useGetEstimateSupplyRequestPositionList,
} from '@entities/requestMaterial';

import cls from './ModalBody.module.css';
import { BodyLoader, RequestsTable } from '@features/AddRequestMaterialModal/ui';

interface ModalBodyProps {
    classes?: string;
    search: string;
    manualPositions: IRequestMaterialSinglePosition[];
}

export const ModalBody = ({ classes, search, manualPositions }: ModalBodyProps) => {
    const { t } = useTranslation();
    const { data: stages = [], isLoading } = useGetEstimateSupplyRequestPositionList();

    if (isLoading) {
        return <BodyLoader />;
    }

    return (
        <Flex direction="column" gap={16} className={cn(cls.ModalBody, [classes])}>
            <RequestsTable stages={stages} search={search} manualPositions={manualPositions} />
        </Flex>
    );
};
